/** Get Dashboard Chart data */
export const LOADING = "LOADING";
export const RESULT = "RESULT";

export const GET_VM_STATUS = "ADMIN_DASHBOARD_GET_VM_STATUS";
export const GET_NETT_SETTLEMENT = "ADMIN_DASHBOARD_GET_NETT_SETTLEMENT";
